/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CivAction } from '../model/civAction';
import { CivIntMapAction } from '../model/civIntMapAction';
import { CivIntMapFromToAction } from '../model/civIntMapFromToAction';
import { CivMapAction } from '../model/civMapAction';
import { CivUuidMapAction } from '../model/civUuidMapAction';
import { GameEngineDto } from '../model/gameEngineDto';
import { MapAction } from '../model/mapAction';
import { UuidBoolAction } from '../model/uuidBoolAction';
import { UuidSideAction } from '../model/uuidSideAction';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EngineMovementService {

    protected basePath = 'http://localhost:8080/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Destroy armies
     * Destroy map armies
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public destroyArmies(body: CivIntMapAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public destroyArmies(body: CivIntMapAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public destroyArmies(body: CivIntMapAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public destroyArmies(body: CivIntMapAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling destroyArmies.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling destroyArmies.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/movement/destroy-armies`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Destroy positionable
     * Destroy map positionable object: city, hut, village, building, wonder marker or great person marker
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public destroyPositionable(body: MapAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public destroyPositionable(body: MapAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public destroyPositionable(body: MapAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public destroyPositionable(body: MapAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling destroyPositionable.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling destroyPositionable.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/movement/destroy-positionable`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Destroy scouts
     * Destroy map scouts
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public destroyScouts(body: CivIntMapAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public destroyScouts(body: CivIntMapAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public destroyScouts(body: CivIntMapAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public destroyScouts(body: CivIntMapAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling destroyScouts.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling destroyScouts.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/movement/destroy-scouts`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Flip tile
     * Set tile face up or face down
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public flipTile(body: UuidBoolAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public flipTile(body: UuidBoolAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public flipTile(body: UuidBoolAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public flipTile(body: UuidBoolAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling flipTile.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling flipTile.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/movement/flip-tile`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Move armies
     * Move map armies
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public moveArmies(body: CivIntMapFromToAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public moveArmies(body: CivIntMapFromToAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public moveArmies(body: CivIntMapFromToAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public moveArmies(body: CivIntMapFromToAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling moveArmies.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling moveArmies.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/movement/move-armies`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Move scouts
     * Move map scouts
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public moveScouts(body: CivIntMapFromToAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public moveScouts(body: CivIntMapFromToAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public moveScouts(body: CivIntMapFromToAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public moveScouts(body: CivIntMapFromToAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling moveScouts.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling moveScouts.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/movement/move-scouts`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Place hands hut
     * Place hut from civilization sheet
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public placeHandsHut(body: CivUuidMapAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public placeHandsHut(body: CivUuidMapAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public placeHandsHut(body: CivUuidMapAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public placeHandsHut(body: CivUuidMapAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling placeHandsHut.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling placeHandsHut.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/movement/place-hands-hut`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Place hands village
     * Place village from civilization sheet
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public placeHandsVillage(body: CivUuidMapAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public placeHandsVillage(body: CivUuidMapAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public placeHandsVillage(body: CivUuidMapAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public placeHandsVillage(body: CivUuidMapAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling placeHandsVillage.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling placeHandsVillage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/movement/place-hands-village`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Place market hut
     * Place market hut to map
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public placeMarketHut(body: MapAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public placeMarketHut(body: MapAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public placeMarketHut(body: MapAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public placeMarketHut(body: MapAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling placeMarketHut.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling placeMarketHut.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/movement/place-market-hut`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Place market village
     * Place market village to map
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public placeMarketVillage(body: MapAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public placeMarketVillage(body: MapAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public placeMarketVillage(body: MapAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public placeMarketVillage(body: MapAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling placeMarketVillage.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling placeMarketVillage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/movement/place-market-village`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Rotate tile
     * Rotate tile to left or right
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rotateTile(body: UuidSideAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public rotateTile(body: UuidSideAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public rotateTile(body: UuidSideAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public rotateTile(body: UuidSideAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling rotateTile.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling rotateTile.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/movement/rotate-tile`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Take market hut
     * Take market hut
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public takeMarketHut(body: CivAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public takeMarketHut(body: CivAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public takeMarketHut(body: CivAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public takeMarketHut(body: CivAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling takeMarketHut.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling takeMarketHut.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/movement/take-market-hut`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Take market village
     * Take market village
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public takeMarketVillage(body: CivAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public takeMarketVillage(body: CivAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public takeMarketVillage(body: CivAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public takeMarketVillage(body: CivAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling takeMarketVillage.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling takeMarketVillage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/movement/take-market-village`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Take positionable
     * Take positionable object from map to hands: hut, village or great person marker
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public takePositionable(body: CivMapAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public takePositionable(body: CivMapAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public takePositionable(body: CivMapAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public takePositionable(body: CivMapAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling takePositionable.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling takePositionable.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/movement/take-positionable`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
